import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';

export function Navbar() {
  const { user, logout } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="h-14 bg-raised border-b border-zinc-800 flex items-center justify-between px-4">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <img src="/owl-logo.svg" alt="WiserWeb" className="h-8 w-auto" />
        <span className="text-lg font-semibold">
          <span className="gradient-text">WiserWeb</span>
          <span className="text-zinc-400">.AI</span>
        </span>
      </div>

      {/* User Menu */}
      <div className="flex items-center gap-4">
        {/* Settings */}
        <button className="p-2 text-zinc-400 hover:text-zinc-200 rounded-lg hover:bg-zinc-800 transition-colors">
          <span className="material-icons">settings</span>
        </button>

        {/* User Dropdown */}
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-zinc-800 transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-primary flex items-center justify-center text-white font-medium">
              {user?.email?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="text-left hidden sm:block">
              <p className="text-sm font-medium text-zinc-200">
                {user?.name || user?.email?.split('@')[0] || 'User'}
              </p>
              <p className="text-xs text-zinc-500">{user?.tier || 'Free'}</p>
            </div>
            <span className="material-icons text-zinc-400">expand_more</span>
          </button>

          {showMenu && (
            <>
              <div
                className="fixed inset-0 z-10"
                onClick={() => setShowMenu(false)}
              />
              <div className="absolute right-0 top-full mt-2 z-20 w-48 bg-elevated border border-zinc-700 rounded-lg shadow-lg py-1">
                <div className="px-4 py-2 border-b border-zinc-700">
                  <p className="text-sm font-medium text-zinc-200">
                    {user?.email}
                  </p>
                </div>
                <a
                  href="https://wiserwebcloud.com/dashboard"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 text-sm text-zinc-300 hover:bg-zinc-700"
                >
                  <span className="material-icons text-lg">dashboard</span>
                  Dashboard
                </a>
                <a
                  href="https://wiserwebcloud.com/settings"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 text-sm text-zinc-300 hover:bg-zinc-700"
                >
                  <span className="material-icons text-lg">account_circle</span>
                  Account
                </a>
                <button
                  onClick={logout}
                  className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-400 hover:bg-zinc-700"
                >
                  <span className="material-icons text-lg">logout</span>
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
